export const WORKSPACE_IDS = {
  ECHO_MARKETING: '678e0b45494114bb21dd92fe',
  KYOBO: '680629f5b6399b30f3f69a13',
  EVERYDAY_DOSE: '67b77a15c185d9bebc12a01a',
  TRUST_AND_WILL: '6712b326a9fef0e415cfefc7',
  YUHAN_KIMBERLY: '692e49595a60aa0b9044ca82',
  HITE_JINRO: '69aac44c9a8557f8df2f7743',
  FACE_CREAM: '6874b4a1a0db1103087085d9',
  HEY_REACH: '66f25d3b6191892477e1e04f',
  PAPAYA: '691ec7d9a949d7f9d869f9b9',
  BOUNDLESS: '6557edd6a3c5f728a1565beb',
} as const;
